// Shared helpers for the premium (tile-less) quote maps.

export const hasCoords = (p) => p && typeof p.lat === "number" && typeof p.lng === "number";

// Equirectangular projection → percentage position on the world map image.
export const project = (lat, lng) => ({
  x: ((lng + 180) / 360) * 100,
  y: ((90 - lat) / 180) * 100,
});

export const mapsPoint = (p) =>
  hasCoords(p)
    ? `https://www.google.com/maps/search/?api=1&query=${p.lat},${p.lng}${p.place_id ? `&query_place_id=${p.place_id}` : ""}`
    : `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(p?.name || p?.address || "")}`;

export const mapsDirections = (a, b) => {
  const o = hasCoords(a) ? `${a.lat},${a.lng}` : encodeURIComponent(a?.name || a?.address || "");
  const d = hasCoords(b) ? `${b.lat},${b.lng}` : encodeURIComponent(b?.name || b?.address || "");
  return `https://www.google.com/maps/dir/?api=1&origin=${o}&destination=${d}`;
};

export const placeLabel = (p, fallback) => p?.name || p?.address || fallback || "";
